import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class RatePlan
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 */
export class RatePlan extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name', 'description', 'policies' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'RATE_PLAN_NAME_IN_ENGLISH',
                commonLabel: 'Rate plan name'
            },
            name_ar: {
                label: 'RATE_PLAN_NAME_IN_ARABIC',
                commonLabel: 'Rate plan name'
            },
            derived_ratio: {
                label: 'DERIVED_RATIO',
                messages: {
                    notGreaterThan: 'DERIVED_RATIO_SHOULD_NOT_EXCEED_100'
                }
            },
            description: {
                label: 'DESCRIPTION_IN_ENGLISH',
                commonLabel: 'Rate plan description'
            },
            description_ar: {
                label: 'DESCRIPTION_IN_ARABIC',
                commonLabel: 'Rate plan description'
            },
            policies: {
                label: 'POLICIES_IN_ENGLISH',
                commonLabel: 'Rate plan policies'
            },
            policies_ar: {
                label: 'POLICIES_IN_ARABIC',
                commonLabel: 'Rate plan policies'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', ...RatePlan.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'status', 'derived', 'derived_higher', 'derived_fixed_amount',
        'derived_ratio', 'promotion', 'promotion_code', 'images', 'intervals', 'reservation_sources', 'addons', 'is_copy', 'origin_name', 'origin_name_ar')(RatePlan);


// WEBPACK FOOTER //
// ./src/pms-api/models/rate-plan.model.js